import styled, { css } from 'styled-components';
import { MainBtn } from 'components/Buttons';

interface IOpenModule {
  open: boolean;
}

export const ModulesContentWrapper = styled.div`
  width: 100%;
  padding-top: 80px;

  .title {
    margin-bottom: 30px;

    h4 {
      font-family: 'Inter Bold';
      font-size: var(--font-largest);
    }
  }
`;

export const ModulesCard = styled.div<IOpenModule>`
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin-bottom: 40px;

  ${({ open }) => css`
    box-shadow: ${open
      ? '-5px 5px 30px rgba(0, 0, 0, 0.2)'
      : '0px 0px 20px rgba(0, 0, 0, 0.1)'};
  `}

  .module-content {
    display: flex;
    align-items: center;
    padding: 25px;
    position: relative;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .module-info {
      flex: 1;

      p {
        font-size: var(--font-medium);
      }
    }

    .image-wrapper {
      width: 50px;
      height: 50px;
      background-color: var(--primary-color);
      border-radius: 10px;
      padding: 10px;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .module-title {
      font-size: 25px;
      font-family: 'Inter Bold';
    }

    .module-description {
      color: var(--primary-color);
      margin-bottom: 8px;
      display: inline-block;
    }

    .module-actions {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      gap: 22px;
      align-items: flex-end;

      @media (max-width: 768px) {
        align-self: center;
        align-items: center;
      }
    }

    .material-type {
      color: var(--primary-color);
      background-color: var(--color-light-pink);
      border-radius: 25px;
      padding: 6px 20px;
    }
  }

  .lessons-list {
    margin: 0 25px;
    transition: all 0.9s !important;
    overflow: hidden;
    padding-right: 25px;
    padding-left: 25px;

    ${({ open }) => css`
      border-top: ${open ? '1px solid var(--color-light-pink)' : 'none'};
      max-height: ${open ? '1000px' : '0'};
      padding-top: ${open ? '25px' : '0'};
      padding-bottom: ${open ? '25px' : '0'};
    `}

    .lesson {
      display: flex;
      align-items: center;
      gap: 13px;
      padding: 10px 0;
      cursor: pointer;
    }
  }

  .open-lessons {
    text-align: center;

    span {
      color: var(--primary-color);
      font-size: var(--font-small);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding-bottom: 10px;
    }
  }
`;

export const ModuleMainBtn = styled(MainBtn)`
  height: 30px;
  padding: 0 22px;

  img {
    width: 14px;
  }
`;
